<template>
    <transition name="delete-confirm-modal" appear>
        <div v-if="show" class="delete-confirm-modal" @click="$emit('cancel')">
            <div class="delete-confirm-modal__dialog" @click.stop>
                <div class="delete-confirm-modal__title">Вы действительно хотите удалить этот элемент?</div>
                <div class="delete-confirm-modal__text">Действие нельзя будет отменить.</div>
                <div class="d-flex justify-content-end gap-2 mt-4">
                    <button type="button" class="btn btn-secondary" @click="$emit('cancel')">Отмена</button>
                    <button type="button" class="btn btn-danger" @click="$emit('confirm')">Удалить</button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "DeleteConfirmModal",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["cancel", "confirm"],
};
</script>

<style scoped>
.delete-confirm-modal {
    position: fixed;
    inset: 0;
    z-index: 1050;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background: rgba(0, 0, 0, 0.38);
    font-family: 'Segoe UI', Tahoma, Verdana, sans-serif;
}

.delete-confirm-modal__dialog {
    width: min(360px, 100%);
    padding: 22px;
    border-radius: 8px;
    background: #fff;
    color: #434343;
    border-top: 4px solid #dc3545;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
}

.delete-confirm-modal__title {
    color: #212529;
    font-size: 16pt;
    font-weight: 700;
    line-height: 1.25;
}

.delete-confirm-modal__text {
    margin-top: 8px;
    color: #6c757d;
    font-size: 11pt;
    font-weight: 400;
    line-height: 1.45;
}

.delete-confirm-modal-enter-active,
.delete-confirm-modal-leave-active {
    transition: opacity 0.16s ease-out;
}

.delete-confirm-modal-enter-active .delete-confirm-modal__dialog,
.delete-confirm-modal-leave-active .delete-confirm-modal__dialog {
    transition: transform 0.16s ease-out;
}

.delete-confirm-modal-enter-from,
.delete-confirm-modal-leave-to {
    opacity: 0;
}

.delete-confirm-modal-enter-from .delete-confirm-modal__dialog,
.delete-confirm-modal-leave-to .delete-confirm-modal__dialog {
    transform: translateY(8px);
}
</style>
